export default {
  genders (state) {
    return {
      ...state,
      storeName: 'genders'
    }
  }
}
